import { NavigationContentFragment } from "../../../graphql/graphql.ts";
import { C100NavigationProps } from "./C100Navigation.tsx";
import { linkTransformer } from "../../../data/transformer/linkTransformer.ts";
import { LocaleConfig } from "../../../utils/GlobalContext.ts";

export function navigationTransformer(
  entry: NavigationContentFragment,
  localeConfig: LocaleConfig,
): C100NavigationProps | null {
  if (!entry) {
    return null;
  }

  const { pageName, linksCollection, callToAction } = entry;

  return {
    pageName: pageName ?? "",
    currentLocale: localeConfig.currentLocale,
    links:
      linksCollection?.items
        .filter(Boolean)
        .map((link) => linkTransformer({ link, localeConfig })) ?? [],
    callToAction: linkTransformer({ link: callToAction, localeConfig }),
  };
}
